import React from 'react';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import {
  Dialog,
  Divider,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ConfirmDialog = ({
  title,
  divider,
  content,
  children,
  rejectText,
  confirmText,
  confirmAction,
  btnClassName,
  disabled,
  dialogClassName,
  actionsClassName,
  disableConfirmButton,
  icon,
  titleDivider,
  titleClassName,
}) => {
  if (children?.length > 1) {
    throw Error('ConfirmDialog must have exactly one child element.');
  }

  const { t } = useTranslation();
  const [opened, toggleModal] = React.useState(false);

  return (
    <>
      <span onClick={disabled ? null : () => toggleModal(true)}>
        {children}
      </span>
      {opened ? (
        <Dialog open={opened} onClose={() => toggleModal(false)}>
          <DialogTitle className={titleClassName} id="alert-dialog-title">
            {t(title)}
          </DialogTitle>
          {icon && (
            <IconButton
              style={{
                position: 'absolute',
                top: '5px',
                right: '10px',
              }}
              onClick={() => toggleModal(false)}>
              <CloseIcon style={{ fontSize: '18px', color: 'grey' }} />
            </IconButton>
          )}
          {icon ||
            (titleDivider && <Divider style={{ marginBottom: '0.5rem' }} />)}
          {content ? (
            <DialogContent className={dialogClassName}>
              <DialogContentText
                style={{ whiteSpace: 'pre-wrap' }}
                id="alert-dialog-description">
                {content}
              </DialogContentText>
            </DialogContent>
          ) : null}
          {divider && <Divider />}
          <DialogActions className={actionsClassName}>
            <Button
              onClick={() => toggleModal(false)}
              color="primary"
              variant={btnClassName && 'outlined'}>
              {t(rejectText)}
            </Button>
            {disableConfirmButton ? null : (
              <Button
                onClick={() => {
                  confirmAction();
                  toggleModal(false);
                }}
                color="primary"
                autoFocus
                className={btnClassName}>
                {t(confirmText)}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

ConfirmDialog.defaultProps = {
  content: '',
  rejectText: 'no',
  confirmText: 'yes',
  title: 'confirmation_message',
  confirmAction: () => {},
  icon: false,
};

ConfirmDialog.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  rejectText: PropTypes.string,
  confirmAction: PropTypes.func,
  confirmText: PropTypes.string,
  children: PropTypes.node.isRequired,
  icon: PropTypes.boolean,
};

export default ConfirmDialog;
